import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './RemoveDownloadModal.css';

/**
 * Confirmation modal for removing a downloaded list
 */
function RemoveDownloadModal({
  isOpen,
  listTitle,
  onConfirm,
  onCancel,
  isRemoving,
}) {
  // Lock body scroll when modal is open
  useEffect(() => {
    if (!isOpen) return;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  // Handle ESC key to cancel
  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e) => {
      if (e.key === 'Escape' && !isRemoving) onCancel();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen, isRemoving, onCancel]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="remove-download-overlay" onClick={onCancel}>
      <div className="remove-download-modal" onClick={(e) => e.stopPropagation()}>
        <div className="remove-download-header">
          <TrashIcon />
          <h3>Remove Download?</h3>
        </div>

        <div className="remove-download-content">
          <p className="remove-list-title">{listTitle}</p>
          <p className="remove-description">
            This list will no longer be available offline. You can download it again anytime.
          </p>
        </div>

        <div className="remove-download-footer">
          <button
            className="remove-cancel-btn"
            onClick={onCancel}
            disabled={isRemoving}
          >
            Cancel
          </button>
          <button
            className="remove-confirm-btn"
            onClick={onConfirm}
            disabled={isRemoving}
          >
            {isRemoving ? 'Removing...' : 'Remove'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

const TrashIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <line x1="10" y1="11" x2="10" y2="17" />
    <line x1="14" y1="11" x2="14" y2="17" />
  </svg>
);

export default RemoveDownloadModal;
